import { CircularProgress, Grid } from "@mui/material";
import { Box } from "@mui/system";
import { useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import PageRoutes from "../Config/PageRoutes";
import "../Style/CommoditiesMenu.scss";
import { BsArrowLeftCircleFill } from "react-icons/bs";

// csv
import csv1 from "../Data/EUMACP/Commodity/EU-MACP-Commodity-of-samples-with-quantified-above-the-MRL.csv";
import csv2 from "../Data/EUMACP/Commodity/EU-MACP-Commodity-No-of-quantified-residues-per-sample.csv";
import csv4 from "../Data/EUMACP/Commodity/EU-MACP-Commodity-Residues-expressed-as-percentage-of-MRL-Above-100.csv";
import csv5 from "../Data/EUMACP/Commodity/EU-MACP-Commodity-Pesticides-with-significant.csv";
import csv6 from "../Data/EUMACP/Commodity/EU-MACP-Commodity-summary-of-findings-table-per-commodity.csv";

// charts
import RingChart from "../Components/Charts/RingChart";
import ScatterDotsChart from "../Components/Charts/ScatterDotsChart";
import HorizontalBarChartWIthNegative2 from "../Components/Charts/HorizontalBarChartWIthNegative2";
import SummaryDataGrid from "../Components/Commodity/SummaryDataGrid";
import DodgeBarCommodity from "../Components/Charts/DodgeBarCommodity";

// maps
import CommodityMap from "../Components/Maps/CommodityMap";
import mapJSON from "../Data/JSON/World.json";
import mapCSV from "../Data/EUMACP/Commodity/EU MACP-Commodity-Samples-with-quantified-residues-above-the-MRL-and-non-compliant-by-country-of-origin.csv";

// components
import ButtonsSelect from "../Components/Common/ButtonsSelect";
import CircleSvg from "./../Components/CircleSvg";
import Intro from "../Components/Commodity/Intro";
import * as React from "react";

const Commodity = (props) => {
  const { id } = useParams();
  const capitalize = id.charAt(0).toUpperCase() + id.slice(1);
  const denormalize = capitalize.replace("_", " ").replace("-", "/");
  const [active, setActive] = useState(false);
  const [residuesCSV, setResiduesCSV] = useState(csv4);
  const [residuesActive, setResiduesActive] = useState(0);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }
    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const [buttonsFilter, setButtonsFilter] = useState(
    "Above legal limit result"
  );

  const [isLoading, setIsLoading] = useState(true);

  const handleButtonClick = (value) => {
    if (value === 0) {
      setButtonsFilter("Above legal limit result");
    } else {
      setButtonsFilter("Result non compliant for pesticides");
    }
  };

  const [chartIsLoading, setChartIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    setChartIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setChartIsLoading(false);
    }, 500);
  }, [id]);
  function ScrollDownClick(ref) {
    // console.log("scroled");
    useEffect(() => {
      function handleScrollDown(event) {
        window.onwheel = (event) => {
          if (event.deltaY >= 0) {
            // Wheel Down
            setActive(true);
            // console.log("Down");
          } else {
            // Wheel Up
            setActive(false);
            // console.log("Up");
          }
        };
      }

      document.addEventListener("wheel", handleScrollDown);
      return () => {
        document.removeEventListener("wheel", handleScrollDown);
      };
    }, [ref]);
  }
  const container = useRef(null);
  ScrollDownClick(container);
  return (
    <Grid
      container
      ref={container}
      direction="column"
      className="wrapper-commodity"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        contain: "paint",
      }}
    >
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid
          p={2}
          container
          direction="column"
          className="chapterOneWrapper"
          style={{
            maxWidth: "1400px",
            paddingTop: "0",
          }}
        >
          <Box
            sx={{
              textAlign: "left",
              position: "sticky",
              top: { xs: "3.5rem", md: "1rem" },
              left: { xs: "20px", md: "150px" },
              zIndex: 10,

              width: { xs: "15%", md: "25%" },
            }}
          >
            <Link to={PageRoutes.CHAPTER_ONE}>
              <Box className="back-button-wrapper " display="flex">
                <BsArrowLeftCircleFill
                  style={{
                    width: isMobile ? "40px" : "50px",
                    height: isMobile ? "40px" : "50px",
                    color: "#22294d",
                  }}
                />
                <Box
                  sx={{
                    display: { xs: "none", md: "contents" },
                  }}
                >
                  <p
                    className={active ? "back-button active" : "back-button"}
                    style={{
                      marginBottom: 0,
                      marginLeft: "10px",
                      paddingTop: "11px",
                    }}
                  >
                    <b>Back to overall results</b>
                  </p>
                </Box>
              </Box>
            </Link>
          </Box>
          <Grid
            item
            container
            direction={{ xs: "column", sm: "column", md: "row" }}
            sx={{ marginTop: "0" }}
            justifyContent="center"
          >
            <Box
              paddingTop={{ xs: "5rem", sm: "5rem", md: "2rem" }}
              sx={{
                width: "100%",
                backgroundColor: "#FAFAFA",
                minHeight: "300px",
              }}
            >
              <Intro id={id} name={denormalize} />
            </Box>
          </Grid>

          <Grid
            item
            container
            direction={{ xs: "column", sm: "column", md: "row" }}
            sx={{ marginTop: { xs: "50px", sm: "50px", md: "20px" } }}
            justifyContent="center"
            alignItems="center"
          >
            <Box sx={{ width: { xs: "90%", sm: "90%", md: "60%" } }}>
              {!chartIsLoading && (
                <DodgeBarCommodity
                  legendPosition="bottom"
                  filter={denormalize}
                  commodity
                  title="Percentage of samples with quantified above the MRL"
                  csv={csv1}
                />
              )}
            </Box>
          </Grid>

          <Grid
            item
            container
            direction="column"
            sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
            justifyContent="center"
          >
            {/* <Box sx={{ maxWidth: '100%' }}>
							<ButtonsSelect
								firstButton='Above legal limit'
								secondButton='Non compliant'
								onButtonClick={handleButtonClick}
							/>
						</Box> */}
            <Box sx={{ marginTop: "2rem" }}>
              <CommodityMap
                buttonsFilter={buttonsFilter}
                filter={denormalize}
                csv={mapCSV}
                json={mapJSON}
              />
            </Box>
          </Grid>

          <Grid
            item
            container
            direction={{ xs: "column", sm: "column", md: "row" }}
            sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
            justifyContent="center"
            alignItems="center"
          >
            <Box style={{ position: "absolute", left: "0px" }}>
              <CircleSvg />
            </Box>
            <RingChart
              filter={denormalize}
              title="Number of quantified residues per sample"
              csv={csv2}
            />
          </Grid>

          <Grid
            item
            container
            direction="column"
            sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
            justifyContent="center"
            alignItems="center"
          >
            <Box sx={{ width: "98%" }}>
              <ScatterDotsChart
                residuesActive={residuesActive}
                title="Residues expressed as percentage of MRL"
                filter={denormalize}
                csv={residuesCSV}
              />
              <Box mt={"1rem"} display="flex" justifyContent="center">
                <p
                  style={{
                    fontFamily: "Roboto Condensed, sans-serif",
                    maxWidth: "700px",
                    textAlign: "center",
                  }}
                >
                  Values in the parentheses denote: a. the number of samples
                  below LOQ, b. the number of samples between LOQ and MRL and,
                  c.the number of samples above MRL: e.g. 2,4-D (RD) (a, b, c){" "}
                </p>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            container
            direction={{ xs: "column", sm: "column", md: "row" }}
            sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
            justifyContent="center"
            alignItems="center"
          >
            <Box sx={{ width: { xs: "100%", sm: "100%", md: "70%" } }}>
              <HorizontalBarChartWIthNegative2
                title="Pesticides with significant increase/decrease compared to previous year"
                csv={csv5}
                filter={denormalize}
              />
            </Box>
          </Grid>

          {denormalize === "Poultry fat" && (
            <Grid
              item
              container
              direction={{ xs: "column", sm: "column", md: "row" }}
              sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
              justifyContent="center"
              alignItems="center"
            >
              <Box>
                <p style={{ textAlign: "center" }}>
                  <b>
                    <u>Disclaimer</u>
                  </b>
                </p>
                <p style={{ textAlign: "center", maxWidth: "700px" }}>
                  For the purposes of this visualisation the <b>poultry fat</b>,
                  poultry tissue and poultry muscle samples, and subsequently
                  results, are pooled together.{" "}
                </p>
              </Box>
            </Grid>
          )}

          <Grid
            item
            container
            direction={{ xs: "column", sm: "column", md: "row" }}
            sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
            justifyContent="center"
            alignItems="center"
          >
            <Box sx={{ width: { xs: "100%", sm: "100%", md: "80%" } }}>
              <SummaryDataGrid
                title="Summary of the findings"
                filter={denormalize}
                csv={csv6}
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default Commodity;
